// Constant for Customer Refund Shipment

export const STATUS = {
  PENDING : 'pending',
  SHIPPED : 'shipped'
}

export const COURIER = {
  KGXPRESS: 'kgxpress'
}

export const COURIER_SERVICE_TYPE = {
  REG : 'reg',
  ECO : 'eco'
}
